// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1AEUV","col":"styles_col__3vlWN","fulfillmentStatus":"styles_fulfillmentStatus__1Hczn","emailCol":"styles_emailCol__13u4M"};